import React from 'react';
import styled from 'styled-components';
import ProductCard from './ProductCard';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4rem;
  margin: 0 auto 4rem auto;

  @media (max-width: 768px) { 
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem; 
    
  }
  @media (max-width: 480px) { 
    grid-template-columns: 1fr; 
    gap: 2rem; 
    
  }
`;

function ProductGrid({ products, onItemClick }) {
  return (
    <Grid>
      {products.map((p, i) => (
        <ProductCard key={i} product={p} onClick={onItemClick} />
      ))}
    </Grid>
  );
}

export default ProductGrid;
